import React, { Component } from "react";
import Table from "../../components/Common/table";
import { itemGroupMapCustomerImg } from "../../services/config.json";

class ItemGroupDrawingCustomerDetailTable extends Component {
  columns = [
    // {
    //   path: "selected",
    //   label: " ",
    //   content: (item, index) => (
    //     <Checkbox
    //       onChange={() => this.props.handleCheckPrint(item, index)}
    //       isChecked={item.selected}
    //       id={`${index}Selected`}
    //     />
    //   )
    // },
    {
      path: "idx",
      label: "#",
      content: (customer, index) => (
        <span>{index + 1 }</span>
      ),
    },
    {
      path: "customer_name",
      label: "Customer",
    },
    {
      path: "drawing_category",
      label: "Kategori",
    },
    {
      path: "code",
      label: "Kode",
    },
    {
      path: "customer_code",
      label: "Kode Customer",
    },
    {
      path: "description",
      label: "Deskripsi",
    },
    {
      path: "drawing",
      label: "Drawing",
      content: (item, index) => (
        <React.Fragment>
          {item.is_pdf === "1" ? 
            <label style={{cursor: "pointer", textDecoration: 'underline'}} onClick={()=>this.props.handleOpenPdf(itemGroupMapCustomerImg+item.drawing)}>
              {item.drawing}
            </label>
          :
          <div className="form-group">  
            <img
              style={{
                width: "100%",
              }}
              src={
                itemGroupMapCustomerImg +
                item.drawing
              }
            />
          </div>
          }
          
        </React.Fragment>
      ),
    },
  ];

  hideAction = (column) => {
    let col = column.filter(function (obj) {
      return obj.label !== "action";
    });
    return col;
  };
  render() {
    const { drawing, from, ...rest } = this.props;
    return (
      <Table
        columns={this.columns}
        data={drawing}
        {...rest}
        keyId="id_item_group_map_customer_drawing"
      />
    );
  }
}

export default ItemGroupDrawingCustomerDetailTable;



// WEBPACK FOOTER //
// ./src/views/item_group/itemDrawingCustomerDetailTable.jsx